class HandlerToReasonCodeForm {
    onChangeShowingFields = (value) => {
      const sectionReasonCode = document.querySelector('#ReasonCode div[key="' + App.Forms.ReasonCode.form.getSections()[2].key + '"]');
      sectionReasonCode && sectionReasonCode.classList[value !== '' ? 'add' : 'remove']('show');
      const { damaged, delivery, over, pickup, shorts } = App.Forms.ReasonCode.form.fields;

      switch (value) {
        case 'L': {
          delivery.hide();
          pickup.hide();
          damaged.hide();
          over.show();
          shorts.show();
          shorts.enable();
          return;
        }
        case 'C': {
          delivery.hide();
          pickup.hide();
          damaged.hide();
          over.hide();
          shorts.show();
          shorts.setValue(true);
          shorts.disable();
          return;
        }
        case 'D':{
          delivery.show();
          pickup.show();
          damaged.show();
          over.show();
          shorts.show();
          shorts.enable();
          return;
        }
      }
    }

    eventHandlerToCancelCodeTypeField = (event) => {
      const newValue = event.target.value;
      this.onChangeShowingFields(newValue);
    };

    eventHandlerToTypeField = () => {
      const { reasonCodeType } = App.Forms.ReasonCode.form.fields;
      reasonCodeType.input.addEventListener('change', this.eventHandlerToCancelCodeTypeField);
    }

    init = () => {
      this.eventHandlerToTypeField();
    }
}

/* Model */
class ReasonCodeModel extends App.Models.BaseModel {
    modelUrl = 'ReasonCode';
}

App.Models.ReasonCode = ReasonCodeModel;

/* Collection */
class ReasonCodeCollection extends App.Collections.BaseCollection {
    url = 'ReasonCode';
    model = App.Models.ReasonCode;
}

App.Collections.ReasonCodes = ReasonCodeCollection;

/* Router */
class ReasonCodeRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'ReasonCode';
    const model = App.Models.ReasonCode;
    const collectionClass = App.Collections.ReasonCodes;

    super(entityName, model, collectionClass);
  }

  afterCreateForm = () => {
    const reasonCodeFormHandler = new HandlerToReasonCodeForm();
    reasonCodeFormHandler.init();
  };

  afterPopulateForm = () => {
    const {
        reasonCodeType
    } = App.Forms.ReasonCode.form.fields;
    
    const eventChange = new Event('change');
    reasonCodeType.input.dispatchEvent(eventChange);
  }
}

App.Routers.ReasonCode = ReasonCodeRouter;
